import React from 'react'
import { Controller, FieldValues } from 'react-hook-form';
import SelectInput from './SelectInput';

interface SmashSelectProps extends FieldValues {
    defaultValue?: string;
    placeholder?: string;
    control: any;
    rules: Record<string, string | boolean>
    name: string;
    options: any;
    onChangeHook: (val:string) => void; 
    isInvalid: boolean;
}


const SmashSelect = (props: SmashSelectProps) => {    
  return (
  <div className={props.isInvalid ? 'is-invalid ' : ''}>
    <Controller
        rules={props.rules}
        control={props.control}
        name={props.name}        
        render={({ field: {onChange, ref }}) => <>
            {<SelectInput                                     
                ref={ref}
                placeholder={props.placeholder}
                defaultValue={props.defaultValue}
                options={props.options}
                onChange={(val:any) => {
                    onChange(val?.value);
                    props.onChangeHook(val)
                }}
                isInvalid={props.isInvalid} />
            }
        </>}
    />
  </div>
  )
}

export default SmashSelect